import type { KAPLAYCtx } from '../types.ts'
import { getTiledSize, getFileCacheStr } from '../utils.ts'
import { useMusic } from '../music.ts'

export function useStartScene(k: KAPLAYCtx) {
  const cacheStr = getFileCacheStr()
  k.loadSprite('startBg', `/sprites/scenes/start-bg.png?${cacheStr}`)
  k.loadSprite('startTitle', `sprites/scenes/start-title.png?${cacheStr}`)
  k.loadSprite('startBtnEn', `sprites/scenes/start-btn-en.png?${cacheStr}`)
  k.loadSprite('startBtnPt', `sprites/scenes/start-btn-pt.png?${cacheStr}`)

  k.scene('start', () => {

    const { playMusic } = useMusic(k)

    const halfWidth = k.width() / 2
    const halfHeight = k.height() / 2

    // Image size: 2620x1204
    const imageRatio = 2620 / 1204
    const screenRatio = k.width() / k.height()
    const isWider = screenRatio > imageRatio
    // const sizeUnit = isWider ? k.width() / imageRatio / 100 : k.height() / 100s

    k.add([
      k.sprite('startBg', {
        width: isWider ? k.width() : k.height() * imageRatio,
        height: isWider ? k.width() / imageRatio : k.height(),
      }),
      k.pos(halfWidth, halfHeight),
      k.anchor('center'),
      k.layer('background'),
    ])

    k.add([
      k.sprite('startTitle', {
        width: getTiledSize(14),
        height: getTiledSize(4),
      }),
      k.pos(halfWidth, halfHeight),
      k.anchor('bot'),
    ])

    k.add([
      k.sprite('startBtnEn', {
        width: getTiledSize(5),
        height: getTiledSize(2),
      }),
      k.pos(halfWidth - getTiledSize(0.5), halfHeight + getTiledSize()),
      k.scale(1.5),
      k.anchor('topright'),
      k.area(),
      'btn_start_en',
      'btn_start',
    ])

    k.add([
      k.sprite('startBtnPt', {
        width: getTiledSize(5),
        height: getTiledSize(2),
      }),
      k.pos(halfWidth + getTiledSize(0.5), halfHeight + getTiledSize()),
      k.scale(1.5),
      k.anchor('topleft'),
      k.area(),
      'btn_start_pt',
      'btn_start',
    ])

    k.onClick('btn_start_en', () => {
      k.store.currLang = 'en'
      k.store.currentScene = 'floor08'
      k.go('floor08')
      playMusic()
    })

    k.onClick('btn_start_pt', () => {
      k.store.currLang = 'pt'
      k.store.currentScene = 'floor08'
      k.go('floor08')
      playMusic()
    })
  })

}
